const ArticleNavigation = () => {
  const isLegal = document.body.classList.contains("page-template-template-legal-documents");

  const linksNav = document.querySelector(".article__toc-list"); // контейнер TOC (может быть <ul> — мы всё равно заменим контент)
  const headerEl = document.querySelector("header");
  const tocWrapper = document.querySelector(".article__toc-wrapper");
  let linkClass = isLegal ?  "article__toc-item-link title title--05" : "article__toc-item-link text-m";
  const activeClass = "active";
  const tocNavWrapper = document.querySelector(".article__toc-nav-wrapper");
  const headingsSelector = isLegal
    ? ".article__article h2, .article__article h3, .article__article h4"
    : ".article__article h2";
  const titlesNav = Array.from(document.querySelectorAll(headingsSelector));

  if (!linksNav || !titlesNav.length) return;

  const getHeaderHeight = () =>
    headerEl ? headerEl.getBoundingClientRect().bottom : 0;

  if (tocWrapper) tocWrapper.style.top = `${getHeaderHeight() + 20}px`;


  titlesNav.forEach((h, i) => {
    if (!h.id) h.id = `header-${i}`;
  });

 
  const idToA = new Map();
  const frag = document.createDocumentFragment();

  if (!isLegal) {
   titlesNav.forEach((h) => {
    const li = document.createElement("li");
    const a = document.createElement("a");
    a.href = `#${h.id}`;
    a.className = linkClass;
    a.textContent = (h.innerText || "").trim();
    li.appendChild(a);
    frag.appendChild(li);     
    idToA.set(h.id, a);
  });
  } else {
    const tree = [];
    let curH2 = null;
    let curH3 = null;

    titlesNav.forEach((h) => {
      const level = Number(h.tagName.slice(1)); 
      if (level === 2) {
        curH2 = { el: h, children: [] };
        tree.push(curH2);
        curH3 = null;
      } else if (level === 3 && curH2) {
        curH3 = { el: h, children: [] };
        curH2.children.push(curH3);
      } else if (level === 4 && curH3) {
        curH3.children.push({ el: h, children: [] });
      }
    });
    const createChevron = () => {
      const NS = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(NS, "svg");
      svg.setAttribute("xmlns", NS);
      svg.setAttribute("width", "16");
      svg.setAttribute("height", "16");
      svg.setAttribute("viewBox", "0 0 16 16");
      svg.classList.add("accordion__chevron");

      const path = document.createElementNS(NS, "path");
      path.setAttribute(
        "d",
        "M2.57946 5.23461L7.71071 11.1846C7.85759 11.3549 8.1404 11.3549 8.28884 11.1846L13.4201 5.23461C13.6107 5.01274 13.4388 4.68774 13.131 4.68774L2.86853 4.68774C2.56071 4.68774 2.38884 5.01274 2.57946 5.23461Z"
      );
      path.setAttribute("fill", "#476175");
      svg.appendChild(path);
      return svg;
    };
    const createItem = (node, depth = 0) => {
      const hasChildren = Array.isArray(node.children) && node.children.length > 0;

      // если есть дети — делаем аккордеонный элемент
      if (hasChildren) {
        const item = document.createElement("div");
        item.className = "accordion__item has-children";
        item.dataset.level = String(depth + 2); // 2/3/4

        const title = document.createElement("div");
        title.className = "accordion__title is-collapsible";

        const a = document.createElement("a");
        a.href = `#${node.el.id}`;
        a.className = linkClass;
        a.textContent = (node.el.innerText || "").trim();

        title.appendChild(a);
        title.appendChild(createChevron()); 

        item.appendChild(title);
        idToA.set(node.el.id, a);

        const content = document.createElement("div");
        content.className = "accordion__content";
        node.children.forEach((child) => {
          content.appendChild(createItem(child, depth + 1));
        });
        item.appendChild(content);

        return item;
      }

      // иначе — простой пункт без аккордеона
      const flat = document.createElement("div");
      flat.className = "navigation__item";
      flat.dataset.level = String(depth + 2);

      const a = document.createElement("a");
      a.href = `#${node.el.id}`;
      a.className = linkClass;
      a.textContent = (node.el.innerText || "").trim();

      flat.appendChild(a);
      idToA.set(node.el.id, a);

      return flat;
    };

    tree.forEach((node) => frag.appendChild(createItem(node)));
  }

  linksNav.innerHTML = "";
  linksNav.appendChild(frag);
  const openAncestorsForLink = (aEl) => {
    if (!aEl) return;
    let node = aEl.closest(".accordion__item");
    while (node) {
      node.classList.add("opened");
      const container = node.parentElement;
      Array.from(container.children).forEach((el) => {
        if (el !== node && el.classList && el.classList.contains("accordion__item")) {
          el.classList.remove("opened");
        }
      });
      node = container.closest(".accordion__item");
    }
  };

  const closeAccordionNotContaining = (aEl) => {
    const keep = new Set();
    let node = aEl ? aEl.closest(".accordion__item") : null;
    while (node) {
      keep.add(node);
      node = node.parentElement?.closest?.(".accordion__item") || null;
    }
    linksNav.querySelectorAll(".accordion__item.opened").forEach((item) => {
      if (!keep.has(item)) item.classList.remove("opened");
    });
  };
  const scrollIntoViewInContainer = (container, el, smooth = true) => {
    if (!container || !el) return;
    const c = container.getBoundingClientRect();
    const r = el.getBoundingClientRect();
    const pad = 8;

    if (r.top < c.top + pad) {
      container.scrollBy({ top: r.top - c.top - pad, behavior: smooth ? "smooth" : "auto" });
    } else if (r.bottom > c.bottom - pad) {
      container.scrollBy({ top: r.bottom - c.bottom + pad, behavior: smooth ? "smooth" : "auto" });
    }
  };
  const clearActive = () => {
    linksNav.querySelectorAll(`.${activeClass}`).forEach((el) => {
      el.classList.remove(activeClass);
    });
  };
  const setActive = (id) => {
    clearActive();
    const a = idToA.get(id);
    if (a){
      a.classList.add(activeClass);
      scrollIntoViewInContainer(tocNavWrapper, a, true);
       if (isLegal && !isAnimating ) {
        openAncestorsForLink(a);         
        closeAccordionNotContaining(a);   
      }
    }
  };

  let isAnimating = false;
  let animTimer = null;

  const finishAnimation = () => {
     isAnimating = false;
    updateActive();
  };

  linksNav.addEventListener("click", (e) => {
    const a = e.target.closest(".article__toc-item-link");
    if (!a) return;
    e.preventDefault();
   
    
    const id = a.hash.slice(1);
    const target = document.getElementById(id);
    if (!target) return;

    isAnimating = true;
    const top =
      Math.floor(window.scrollY + target.getBoundingClientRect().top) -
      getHeaderHeight();
    window.scrollTo({ top, behavior: "smooth" });

    if ("onscrollend" in window) {
      const onEnd = () => {
        window.removeEventListener("scrollend", onEnd);
        finishAnimation();
      };
      window.addEventListener("scrollend", onEnd);
    } else {
      const distance = Math.abs(top - window.scrollY);
      const est = Math.min(800, Math.max(250, Math.round(distance * 0.6)));
      clearTimeout(animTimer);
      animTimer = setTimeout(finishAnimation, est);
    }
  });

  let ticking = false;

  const pickActiveId = () => {
    const navH = getHeaderHeight();
    let activeId = null;

    for (let i = 0; i < titlesNav.length; i++) {
      const top = titlesNav[i].getBoundingClientRect().top - navH - 1;
      if (top <= 0) activeId = titlesNav[i].id;
      else break;
    }
    if (!activeId) activeId = titlesNav[0].id;

    const atBottom =
      Math.ceil(window.scrollY + window.innerHeight) >=
      Math.floor(document.documentElement.scrollHeight);
    if (atBottom) activeId = titlesNav[titlesNav.length - 1].id;

    return activeId;
  };

  const updateActive = () => {
    if (!isAnimating) setActive(pickActiveId());
    ticking = false;
  };

  const onScroll = () => {
    if (isAnimating) return;
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateActive);
    }
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", () => {
    if (tocWrapper) tocWrapper.style.top = `${getHeaderHeight() + 20}px`;
    updateActive();
  });

  updateActive();
};

export default ArticleNavigation;
